<template>
  <div class="price-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>夏令营</el-breadcrumb-item>
      <el-breadcrumb-item>价格管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-button
            v-if="hasPerm('system:price:add')"
            type="primary"
            @click="handleAdd"
            >添加</el-button
          >

         <el-button
        
            type="primary"
            @click="handlePay"
            >Pay</el-button
          >
        </el-col>
      </el-row>
      <el-table
      
        size="mini"
        :data="PriceList"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
        default-expand-all
        :tree-props="{ children: 'children' }"
      >
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="价格" prop="price"></el-table-column>
        <el-table-column width="170" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="hasPerm('system:price:edit')"
              type="primary"
              size="mini"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="hasPerm('system:price:delete')"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[2, 5, 10, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!--新增用户弹框-->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="33%">
        <el-form
          :rules="addFormRules"
          ref="addUser"
          :model="addForm"
          size="mini"
          :inline="true"
          label-width="80px"
        >
          <el-form-item prop="name" label="名称">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item prop="price" label="价格">
            <el-input type="price" v-model="addForm.price"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmBtn">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {WxPay, GetSummerPriceList, GetSummerPriceById,UpdateSummerPriceById,AddSummerPrice,DeleteSummerPriceById } from "@/request/api";
export default {
  data() {
    return {
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 5,
      },
      total: 0,
      PriceList: [],
      //表格高度
      // tableHeight: 0,
      dialogTitle: "",
      //新增用户弹框显示 影藏
      dialogVisible: false,
      addFormRules: {
        name: [
          {
            required: true,
            min: 2,
            max: 10,
            trigger: "blur",
            message: "请输入名称,长度2-10",
          },
        ],
        price: [
          {
            required: true,
            min: 1,
            max: 15,
            trigger: "blur",
            message: "请输入价格",
          },
        ],
      },
      addForm: {
        id: "",
        name: "",
        price: "",
      },
      editTag: "",
    };
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.tableHeight = window.innerHeight - 210; //后面的50：根据需求空出的高度，自行调整
  //   });
  // },
  created() {
    this.getPriceList();
  },
  methods: {
    handlePay(){
      const param={
        out_trade_no:"123456",
        total_fee:100,
        openid:"wx4774316a7eb9b567"
      }
      WxPay(param).then(res=>{
        console.log(res)
      })
    },
    getPriceList() {
      GetSummerPriceList(this.queryInfo).then((res) => {
        console.log(res);
        if (res.data.code === 1) {
          this.PriceList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleAdd() {
      this.editTag = "0";
      this.resetForm("addUser");
      this.dialogTitle = "新增价格";
      this.dialogVisible = true;
    },
    handleEdit(row) {
      console.log(row);
      this.resetForm("addUser");
      this.dialogTitle = "编辑价格";
      this.dialogVisible = true;
      this.editTag = "1";
      //根据用户id查询需要编辑的用户信息
      this.getSummerPriceById(row.id);
    },
    getSummerPriceById(userId) {
      let param = {
        id: userId,
      };
      GetSummerPriceById(param).then((res) => {
        console.log("GetUserById-->", res);
        if (res.data.code == 1) {
          this.addForm = res.data.data;
        }
      });
    },

    handleDelete(row) {
    this.$confirm("确定删除吗 ?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let param = {
          id: row.id,
        };
        DeleteSummerPriceById(param).then((res) => {
          if (res.data.code === 1) {
            this.getPriceList();
          }
          this.$message({
            message: res.data.msg,
            type: res.data.code === 1 ? "success" : "warning",
          });
        });
      });
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getPriceList();
    },
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getPriceList();
    },

    confirmBtn() {
      let param = this.addForm;
      this.$refs.addUser.validate((valid) => {
        console.log("valid-->", valid);
        if (valid) {
          if (this.editTag == "0") {
            AddSummerPrice(param).then((res) => {
              if (res.data.code === 1) this.getPriceList();
            });
          } else {
            UpdateSummerPriceById(param).then((res) => {
              if (res.data.code === 1) this.getPriceList();
            });
          }
          this.dialogVisible = false;
        } 
      });
    },

    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>